import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-cathay',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  standalone: true
})
export class FooterComponent {

}
